export default __webpack_public_path__ + "unlink-symbol.png";